import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccStockRateCourtMin = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.STOCKS_COURT_MIN',
  });
  return result;
};
